import React, { useState, useContext, useEffect } from "react";
import Spinner from "../sample/spinner";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import { toast } from "react-toastify";
import { Redirect } from "react-router";
import { Modal, ModalHeader, ModalBody,  } from "reactstrap";
import MaterialComponent from "../Learner/LearnerAssesment/MaterialComponent";
import {
  Row,
  Col,
  Table,
  CardBody,
  Card,
  CardHeader,
  Button,
} from "reactstrap";
const Installement = () => {
  const context = useContext(UserContext);
  const [installmentList, setInstallmentList] = useState([]);
  const [pdfpath, setPdfpath] = useState("");
  const [modalIsOpen, setIodalIsOpen] = useState(false);
  const [url, setUrl] = useState(
    "https://dashboard.eduplusnow.com/apiHandler/payInstallment"
  );
  useEffect(() => {
    getAllInstallMent();
    setUrl(
      process.env.REACT_APP_PAYMENT_REDIRECTION_URL +
        "apiHandler/payInstallment"
    );
  }, []);
  const getAllInstallMent = async () => {
    axios
      .post("Payment/getInstallMent")
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          setInstallmentList(res.data);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const openModal = (e, pdfpath) => {
    setIodalIsOpen(true);
    setPdfpath(pdfpath);
  };
  const closeModal = (e, pdfpath) => {
    setIodalIsOpen(false);
  };
  if (!context.user?.email) {
    return <Redirect to="/" />;
  }
  return (
    <div> 
      <section class="padding-default2">
        <div class="panel panel-primary card">
          <div class="panel-heading">My Installement's </div>
          <div class="padding-pannele">
            {installmentList != "" ? (
              <>
                {installmentList.arrayList1.map((item, indexitem) => {
                  return (
                    <>
                      {item.isinstallment ? (
                        <>
                          <Row>
                            <Col sm={12}>
                              <Card>
                                <CardHeader  style={{
                                            backgroundColor: "#337ab7",
                                            color: "#fff",
                                          }}>{item?.coursename}</CardHeader>
                                <CardBody>
                                  <Row>
                                    <Col sm={12}>
                                      <Table bordered>
                                        <thead
                                          style={{
                                            backgroundColor: "#337ab7",
                                            color: "#fff",
                                          }}
                                        >
                                          <tr>
                                            <th>Sr.No.</th>
                                            <th>Installement No.</th>
                                            <th>Due Date</th>
                                            <th>Paid Date</th>
                                            <th>Amount</th>
                                            <th>Pay Installement</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item.arrayList1.map(
                                            (institem, index) => {
                                              return (
                                                <>
                                                  <tr>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                      {institem.installment_no}
                                                    </td>
                                                    <td>{institem.due_date}</td>
                                                    <td>
                                                      {institem.paid_date}
                                                    </td>
                                                    <td>{institem.amount}</td>
                                                    <td>
                                                      <Button
                                                       style={{
                                                        backgroundColor: "#337ab7",
                                                        color: "#fff",
                                                      }}
                                                      className="rounded-pill"
                                                        onClick={(e) =>
                                                          openModal(
                                                            e,
                                                            institem.path
                                                          )
                                                        }
                                                      >
                                                       View Receipt
                                                      </Button>
                                                    </td>
                                                  </tr>
                                                </>
                                              );
                                            }
                                          )}
                                          {item.arrayList.map(
                                            (institem, index) => {
                                              return (
                                                <>
                                                  <tr>
                                                    <td>{item.arrayList1.length+index + 1}</td>
                                                    <td>
                                                      {institem.installment_no}
                                                    </td>
                                                    <td>{institem.due_date}</td>
                                                    <td>
                                                      {institem.paid_date}
                                                    </td>
                                                    <td>{institem.amount}</td>
                                                    <td>
                                                      {institem.btn ? (
                                                        <>
                                                       {"-"}
                                                        {installmentList?.smartgateway ? 
                                                        <form
                                                          id="nonseamles"
                                                          method="post"
                                                          name="redirec"
                                                          action={url}
                                                        >
                                                          <input
                                                            type="hidden"
                                                            name="encResp"
                                                            value={
                                                              institem.instrequest
                                                            }
                                                          />
                                                          <input
                                                            type="hidden"
                                                            name="accesskey"
                                                            value="eduplusnow"
                                                          />
                                                          <input
                                                            type="hidden"
                                                            name="payment"
                                                            value="SMARTGATEWAY"
                                                          />
                                                          <Button
                                                            color="success"
                                                            style={{marginTop:"10px"}}
                                                            className="rounded-pill"
                                                          >
                                                            Pay With SMARTGATEWAY
                                                          </Button>
                                                        </form> :""}
                                                        {installmentList?.paytm ? 
                                                        <form
                                                          id="nonseamles"
                                                          method="post"
                                                          name="redirec"
                                                          action={url}
                                                        >
                                                          <input
                                                            type="hidden"
                                                            name="encResp"
                                                            value={
                                                              institem.instrequest
                                                            }
                                                          />
                                                          <input
                                                            type="hidden"
                                                            name="accesskey"
                                                            value="eduplusnow"
                                                          />
                                                          <input
                                                            type="hidden"
                                                            name="payment"
                                                            value="PAYTM"
                                                          />
                                                          <Button
                                                            color="success"
                                                            style={{marginTop:"10px"}}
                                                            className="rounded-pill"
                                                          >
                                                            Pay With Paytm
                                                          </Button>
                                                        </form> :""}
                                                        </>
                                                      ) : (
                                                        "-"
                                                      )}
                                                    </td>
                                                  </tr>
                                                </>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </Table>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <br />
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  );
                })}
                <Modal
                  isOpen={modalIsOpen}
                  onRequestClose={closeModal}
                  size="md"
                  // style={{height:"10px"}}
                  style={{
                    top: "1%",
                    bottom: "70%",
                    height: "60px",
                  }}
                >
                  <ModalHeader toggle={closeModal} className="header-modalc">
                    {" "}
                    Reciept{" "}
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col xs="10" sm="12" md="12">
                        <MaterialComponent
                          contentType="contenttype"
                          contentId="0"
                          materialid="0"
                          materialtype="pdf"
                          materialpath={pdfpath}
                        />
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
              </>
            ) : (
              <Spinner />
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Installement;
